import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const stateBaseEndpoint = ENDPOINTS.STATES;

// States API
export const statesApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["states"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getStates: builder.query({
        query: (payload) => `${stateBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "states" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
    }),
  });

// Export hooks for usage in components

export const { useGetStatesQuery } = statesApi;
